module.exports = __webpack_public_path__ + "files/b403dff67d0f350ae6a1cf8ab2d9b922.png";